const user = {
  namespaced: true,
  state: {
    bangCoin: {},
    userInfo: null,
    permissions: null,
    badgeVal:0,
    pendNum:0,
    oaTableShow:false
  },
  mutations: {
    SET_BANGCOIN: (state, bangCoin) => {
      state.bangCoin = bangCoin
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
      if (userInfo.jurisdict) {
        state.permissions = new Set(userInfo.jurisdict)
      }
    },
    changeData:(state,{key,data})=>{
      state[key] = data
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/components/user.js